export const contactMessagesData = [
  {
    id: 'CM482902',
    name: 'teressa',
    phone: '+1 82392 37359',
    email: 'teresa@example.com',
    message: 'Reminder: Staff meeting tomorrow.',
    img: 'assets/img/coachs/coach-01.jpg',
    date: '25 Mar 2024',
  },
];
